import React from 'react';
import { useParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import WithProcessError from 'hocs/WithProcessError';
import PropTypes from 'prop-types';

import FormItem from 'components/FormItem/FormItem';
import Input from 'components/Input/Input';
import Popup from 'components/Popup/Popup';

import useApi from 'utils/api';
import { useAuth } from 'utils/auth';
import { validateNumber } from 'utils/validate';

import styles from './payment-history-item.scss';

function RefundPopup(props) {
    const api = useApi();
    const auth = useAuth();
    const { clientId } = useParams();
    const queryClient = useQueryClient();

    const { paymentId, amount, onClosed, processError } = props;
    const [refundAmount, setRefundAmount] = React.useState({ value: amount, error: null });
    const [isLoading, setIsLoading] = React.useState(false);
    const [isSuccess, setIsSuccess] = React.useState(false);

    function handleRefundConfirm() {
        if (refundAmount.error !== null) return;

        const companyId = auth?.company.id;
        const params = {
            amount: Number(refundAmount.value),
        };

        setIsLoading(true);
        api.refundClientPayment(companyId, Number(clientId), paymentId, params)
            .then(result => {
                if (result?.success) {
                    setIsSuccess(true);
                    queryClient.invalidateQueries({ queryKey: ['payments', 'client-' + clientId] });
                } else {
                    processError('Не удалось вернуть средства', result?.error_code);
                }
            })
            .catch(error => processError('Не удалось вернуть средства', error))
            .finally(() => {
                setIsLoading(false);
            });
    }

    function handleRefundAmountChange(e) {
        const value = e.target.value;
        const error = validateNumber(value, 1, amount);
        setRefundAmount(prevState => ({ ...prevState, value, error }));
    }

    return (
        <Popup
            shown={true}
            close={isSuccess}
            onConfirm={handleRefundConfirm}
            onClosed={onClosed}
            maxWidth={400}
            loading={isLoading}
            title={'Возврат средств'}
            description={'Возврат производится через терминал, который использовался при оплате.'}>
            <div className={styles.refund}>
                <FormItem label={'Сумма к возврату (руб.)'} required={true} error={refundAmount.error}>
                    <Input type="text" name="refund-amount" value={refundAmount.value} defaultValue={amount} onChange={handleRefundAmountChange} />
                </FormItem>
            </div>
        </Popup>
    );
};

RefundPopup.propTypes = {
    paymentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onClosed: PropTypes.func,
    ...WithProcessError.propTypes,
};

export default WithProcessError(RefundPopup);
